import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
  CustomInbox,
  CustomInboxItemFilters,
  CustomInboxStatus,
  getCustomInboxStatusDisplay
} from '../../../../../../../models/custom-inbox';
import { propExists } from '../../../../../../../utils';

@Component({
  selector: 'app-custom-inbox-item-filters-modal',
  templateUrl: './custom-inbox-item-filters-modal.component.html',
  styleUrls: ['./custom-inbox-item-filters-modal.component.css']
})
export class CustomInboxItemFiltersModalComponent implements OnInit {

  @Input() inputFilters: CustomInboxItemFilters;
  // All statuses: a saved view or URL referencing a retired inbox needs a
  // pinned, labelled option rather than a blank select (removed-record
  // convention).
  @Input() inboxList: CustomInbox[];
  @Input() savedCallback: (newFilters: CustomInboxItemFilters) => undefined;

  filters: CustomInboxItemFilters;
  activeInboxes: CustomInbox[];

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    // Get a deep copy of the input filters. This ensures that the filters are
    // only updated once they are submitted, rather than as the user edits them.
    this.filters = {};

    for (const key of Object.keys(this.inputFilters)) {
      this.filters[key] = this.inputFilters[key];
    }

    // An absent status matches no option and renders the select blank, so
    // normalize to the unresolved default the page applies (new dashboard
    // tiles and emailed-report items arrive with no filters at all).
    if (this.filters.is_resolved !== true && this.filters.is_resolved !== false) {
      this.filters.is_resolved = false;
    }

    this.activeInboxes = (this.inboxList || []).filter(
      inbox => inbox.status === CustomInboxStatus.active
    );
  }

  /**
   * Whether the currently-selected inbox is missing from the active list —
   * i.e. it needs the pinned option to keep the select from rendering blank
   * while the filter silently constrains the query. False when no inbox is
   * selected.
   */
  public selectedInboxInactive(): boolean {
    if (!propExists(this.filters.inbox_id)) { return false; }
    return !this.activeInboxes.some(
      inbox => inbox.id === this.filters.inbox_id
    );
  }

  /**
   * The pinned option's label for an inactive selected inbox: its name plus
   * its status (Retired / Draft), mirroring the "(Removed)" convention.
   */
  public selectedInboxDisplay(): string {
    const match = (this.inboxList || []).find(
      inbox => inbox.id === this.filters.inbox_id
    );
    if (!match) { return 'Unknown Inbox'; }
    return match.name + ' (' + getCustomInboxStatusDisplay(match.status) + ')';
  }

  public handleSubmit() {
    // Backspacing the number input out yields `null`, which unlike undefined
    // survives JSON serialization into a saved emailed-report item or
    // dashboard tile (Django's urlencode rejects None).
    if (this.filters.customer_id === null) {
      this.filters.customer_id = undefined;
    }
    this.savedCallback(this.filters);
    this.activeModal.close();
  }

  public handleClearAll() {
    this.filters = {is_resolved: false};
  }

}
